// extracted by mini-css-extract-plugin
export default {"label":"_f5afc38f","value":"_a5f52622"};